import React from 'react'
import styled from 'styled-components'
import PaginatedTableFilters from '@components/Table/PaginatedTableFilters'
import ExportDataButton from '@components/Table/ExportDataButton'
import { useButtonWidth } from '@services/layout'
import { useUser } from '@state/uses/users'
import SearchBar from '@components/Form/SearchBar'
import { Flex1 } from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({
    title,
    filters,
    searchPlaceholder,
    setSelectedFilters,
    onChangeClicked,
    onChangeSearch,
    selectedFilters,
    page,
    search,
    collection,
    withDateFilters,
    fromDate,
    toDate,
    changeFromDate,
    changeToDate,
    onExportData,
}) => {
    const buttonWidth = useButtonWidth()
    const user = useUser()

    return (
        <Container>
            <Title>{title}</Title>
            <SearchAndExportRow>
                <SearchBarContainer>
                    <SearchBar
                        search={search}
                        onChange={onChangeSearch}
                        searchPlaceholder={searchPlaceholder}
                        onClick={onChangeClicked}
                        width={buttonWidth}
                    />
                </SearchBarContainer>
                <Flex1 />
                <ExportButtonContainer>
                    <ExportDataButton
                        label={
                            i18n.locale === 'en'
                                ? i18n.t('table.export') +
                                  ' ' +
                                  title +
                                  ' ' +
                                  i18n.t('table.list')
                                : i18n.t('table.export') + ' ' + title
                        }
                        collection={collection}
                    />
                </ExportButtonContainer>
            </SearchAndExportRow>
            <PaginatedTableFilters
                filters={filters}
                setSelectedFilters={setSelectedFilters}
                onChangeClicked={onChangeClicked}
                selectedFilters={selectedFilters}
                page={page}
                collection={collection}
                withDateFilters={withDateFilters}
                fromDate={fromDate}
                toDate={toDate}
                changeFromDate={changeFromDate}
                changeToDate={changeToDate}></PaginatedTableFilters>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const SearchAndExportRow = styled.div`
    display: flex;
    /* padding: 0px 20px; */
    /* justify-content: space-between; */
    @media (max-width: 768px) {
        flex-direction: column-reverse;
    }
`
const ExportButtonContainer = styled(Flex1)`
    display: flex;
    justify-content: flex-end;
`
const SearchBarContainer = styled(Flex1)`
    /* padding: 0px; */
`

const Title = styled.div`
    display: flex;
    padding: 0px 20px;
    margin: 20px 0px;
    justify-content: space-between;
`
